import { post, get, put, del } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";
import { getUserDetails } from "./session-service";

async function getHeaders(customHeaders?: any): Promise<any> {
  try {
    const session = getUserDetails();
    const { idToken } = (await fetchAuthSession()).tokens ?? {};
    let headers: any = {
      Authorization: idToken?.toString() || "",
    };
    if (session?.client_id) {
      headers["X-CLIENT-ID"] = session?.client_id;
    }
    if (session?.consultant_id) {
      headers["X-CONSULTANT-ID"] = session?.consultant_id;
    }
    if (session?.site_id) {
      headers["X-SITE-ID"] = session?.site_id;
    }
    return { ...headers, ...customHeaders };
  } catch (e) {
    console.error("getHeaders call failed:", e);
    return {
      Authorization: "",
    };
  }
}

export async function apiPost(
  apiName: string,
  url: string,
  payload_body: any,
  options?: any
): Promise<any> {
  try {
    const headers = await getHeaders(options?.headers);
    if (options?.headers) delete options.headers;

    const restOperation = post({
      apiName: apiName,
      path: url,
      options: {
        ...{
          headers,
          body: payload_body,
        },
        ...(options || {}),
      },
    });

    const { body } = await restOperation.response;
    const response = await body.json();

    return response;
  } catch (e) {
    throw e;
  }
}

export async function apiGet(apiName: string, url: string, options?: any): Promise<any> {
  try {
    const headers = await getHeaders(options?.headers);
    if (options?.headers) delete options.headers;

    const restOperation = get({
      apiName: apiName,
      path: url,
      options: {
        ...{
          headers,
        },
        ...(options || {}),
      },
    });

    const { body } = await restOperation.response;
    const response = await body.json();
    return response;
  } catch (e) {
    console.error("GET call failed:", e);
    throw e;
  }
}

export async function apiPut(
  apiName: string,
  url: string,
  payload_body: any,
  options?: any
): Promise<any> {
  try {
    const headers = await getHeaders(options?.headers);
    if (options?.headers) delete options.headers;

    const restOperation = put({
      apiName: apiName,
      path: url,
      options: {
        ...{
          headers,
          body: payload_body,
        },
        ...(options || {}),
      },
    });

    const { body } = await restOperation.response;
    const response = await body.json();
    return response;
  } catch (e) {
    console.error("PUT call failed:", e);
    throw e;
  }
}

export async function apiDelete(apiName: string, url: string, options?: any): Promise<any> {
  try {
    const headers = await getHeaders(options?.headers);
    if (options?.headers) delete options.headers;

    const restOperation = del({
      apiName: apiName,
      path: url,
      options: {
        ...{
          headers,
        },
        ...(options || {}),
      },
    });

    const response = await restOperation.response;
    return response;
  } catch (e) {
    console.log("DELETE call failed: ", e);
    throw e;
  }
}

export async function tableViewGet(url: string, prams: any): Promise<any> {
  try {
    let filter = prams.filters;
    Object.keys(filter).forEach(key => {
      const value = filter[key]?.value;
      if ((value == null || value == "") && value != false) {
        delete filter[key];
      }
    });

    if (!prams.sortField) prams.sortField = "created_at";

    const response = await apiGet("core", url, {
      queryParams: { ...prams, ...{ filters: JSON.stringify(filter), table_view: true } },
    });
    return response;
  } catch (e) {
    console.log("POST call failed: ", e);
  }
}

export async function dropdownViewGet(url: string, prams?: any): Promise<any[]> {
  try {
    const response = await apiGet("core", url, { queryParams: prams || {} });

    return (response as any).content;
  } catch (e) {
    console.log("POST call failed: ", e);
    return [];
  }
}

export async function duplicate(queryParams: {
  type: string;
  email?: string;
  mobile?: string;
}): Promise<any> {
  try {
    const response = await apiGet("core", "duplicate", { queryParams });

    return !(response as any).content.valid || false;
  } catch (e) {
    console.log("POST call failed: ", e);
  }
}

export async function NprLookup(id: string): Promise<any> {
  try {
    const response = await apiPost("core", "nprLookup", {
      IdNumber: id,
    });

    return (response as any).content;
  } catch (e) {
    console.log("POST call failed: ", e);
  }
}

export async function resetPassword(username: string): Promise<any> {
  try {
    const response = await apiPost("core", "resetPassword", {
      username,
    });
    return !(response as any).content.valid || false;
  } catch (e) {
    console.log("POST call failed: ", e);
  }
}

export async function portalInit(): Promise<any> {
  try {
    const response = await apiGet("core", "portal-init");
    return response.content;
  } catch (e) {
    console.log("POST call failed: ", e);
  }
}
